// Sprint-104c · Today's Snapshot widget.
// Hits GET /api/orders/snapshot — backend resolves scope automatically.
import { useEffect, useState } from "react";
import { Loader2, RefreshCw } from "lucide-react";
import api from "../services/api";

const CARDS = [
  { key: "pending",         label: "Pending",         color: "text-slate-700" },
  { key: "assigned",        label: "Assigned",        color: "text-blue-700" },
  { key: "in_transit",      label: "In Transit",      color: "text-amber-700" },
  { key: "delivered_today", label: "Delivered Today", color: "text-emerald-700" },
  { key: "failed",          label: "Failed",          color: "text-rose-700" },
];

export default function TodaysSnapshot() {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  const load = async () => {
    setLoading(true); setError(false);
    try {
      const { data } = await api.get("/orders-snapshot");
      setData(data);
    } catch { setError(true); }
    finally { setLoading(false); }
  };

  useEffect(() => { load(); }, []);

  return (
    <div className="grid grid-cols-2 sm:grid-cols-5 gap-2 sm:gap-3 mb-6"
         data-testid="todays-snapshot">
      {CARDS.map((c) => (
        <div key={c.key}
             className="bg-white border border-slate-200 rounded-xl px-3 py-3 flex flex-col"
             data-testid={`snapshot-${c.key}`}>
          <div className="text-[10px] uppercase tracking-wider text-slate-400 mb-1">{c.label}</div>
          <div className={`text-2xl font-bold font-['Outfit'] ${c.color}`}>
            {loading ? <Loader2 className="h-5 w-5 animate-spin text-slate-300" />
             : error ? (
               <button onClick={load} className="text-slate-300 hover:text-slate-500"
                       title="Retry" data-testid={`snapshot-retry-${c.key}`}>
                 <RefreshCw className="h-5 w-5" />
               </button>
             ) : (data?.[c.key] ?? 0)}
          </div>
        </div>
      ))}
    </div>
  );
}
